import { missionId } from "utils/urls";
import isMobile from "utils/isMobile";
import { missionNames } from "constants/missions";

const platform = isMobile() ? "mobile" : "desktop";

const config = {
  showLoginHelp: false,
  showTitle: true,
  showRegister: true,
  showChatLinkForDeceasedUsers: false,
  prepopulateEmailOnLogin: false,
  accountRecovery: false,
  showBackToLoginButton: true,
  showRequestPasswordResetLink: true,
};

const defaultConfig = {
  mobile: {
    ...config,
  },
  desktop: {
    ...config,
  },
};

const missionConfig = {
  [missionNames.GOL]: {
    ...defaultConfig,
  },
  [missionNames.NECTAR]: {
    mobile: {
      ...config,
      showLoginHelp: true,
      showTitle: false,
      showChatLinkForDeceasedUsers: true,
      accountRecovery: true,
    },
    desktop: {
      ...config,
      showLoginHelp: true,
      showTitle: false,
      showChatLinkForDeceasedUsers: true,
      accountRecovery: true,
    },
  },
  [missionNames.SMARTSHOP]: {
    mobile: {
      ...config,
      showBackToLoginButton: false,
      showRequestPasswordResetLink: false,
    },
    desktop: {
      ...config,
      showBackToLoginButton: false,
      showRequestPasswordResetLink: false,
    },
  },
  [missionNames.SAVINGCARD]: {
     ...defaultConfig,
   },
};

export default (missionConfig[missionId] || defaultConfig)[platform];
